export enum ConfigName {
  HQ_ADDRESS = 'HQ_ADDRESS',
  HQ_LAT = 'HQ_LAT',
  HQ_LNG = 'HQ_LNG',
  JOURNEY_RETOUR_DELAY = 'JOURNEY_RETOUR_DELAY',
  JOURNEY_BEFORE_APPOINTMENT = 'JOURNEY_BEFORE_APPOINTMENT',
  // JOURNEY_HANDLING_DURATION = 'JOURNEY_HANDLING_DURATION',
  // JOURNEY_HANDLING_DURATION_WHEELCHAIR = 'JOURNEY_HANDLING_DURATION_WHEELCHAIR',
}

export interface ConfigModel {
  id: number
  name: string
  description: string
  value: string
}

export interface DescriptionModel {
  id: number
  description: string
  groupId: number
  ordering: number
}
